// extracted by mini-css-extract-plugin
export default {"spinner":"HFYohbxM1EXNzLWddqX0","load8":"cpKHOUeJkRRBeZqZGPz0","small":"slAEXeLCuAMcZ94DRHlK","medium":"jNzWo2DZGb_8keBh3fNC","large":"gWodl9z2idRQvOOAWdxw"};